import React from "react";

const ColorModeContext = React.createContext(
   {
      colorMode: 'light',
      setColorMode: () => { }
   }
);

export default ColorModeContext;